import { cx } from '@emotion/css';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import React, { memo } from 'react';
import { ix } from '../../../../../../utils/ix';
import { Tooltip } from '../../../../../atoms';
import { Typography } from '../../../../../electrons';
import { useStyles } from './ChipContent.styles';
export const ChipContent = memo(({ activeView, className, hasUnsavedChanges, id, isOpen }) => {
    const classes = useStyles();
    return (React.createElement("div", { className: cx(className, classes.root), id: ix(id, 'chip') },
        React.createElement(Typography, { className: classes.activeViewName, variant: "h2" }, activeView ? activeView.name : 'Unnamed View'),
        hasUnsavedChanges && (React.createElement(Tooltip, { placement: "top", title: "Unsaved changes", id: ix(id, 'unsaved-changes') },
            React.createElement("div", { className: classes.unsavedChangesIndicator }))),
        isOpen ? React.createElement(ExpandLessIcon, { fontSize: "small" }) : React.createElement(ExpandMoreIcon, { fontSize: "small" })));
});
//# sourceMappingURL=ChipContent.js.map